import { ObjectStore } from 'ef/util';

(function(EF) {
  var ProgressTracker = Backbone.Model.extend({
    initialize: function(attrs, options) {
      this.module = options.module;
      this.key = 'progress:' + attrs.module_key;
      if(EF.options.local) {
        this.storage = window.LocalStorageWrapper;
      }
      else {
        this.storage = ObjectStore;
      }
    },

    // Saves the progress for the given page or content page. Simple right now... plans to
    // make this smarter with a buffered progress sync
    //
    save: function(page, cb) {
      EF.ContentProvider.ProgressService.saveProgress(this, page, cb);
    },

    savePage: function(contentPage, data, callback) {
      var progress = this.get();
      if(!progress) {
        progress = {};
      }

      progress[data.activity_key] = (progress[data.activity_key] || {});
      progress[data.activity_key][data.key] = data;

      if(EF.options.local || EF.enrollment.get('demoMode') === 'preview') {
        this._saveLocal(progress, this._finalizeSave(contentPage, callback));
      }
      else {
        // filter out injected pages so that we don't save remote progress
      const isCustom = Object.prototype.hasOwnProperty.call(contentPage.attributes, 'custom') && contentPage.attributes.custom;
      if(!isCustom || isCustom === 'replace') {
        // save page remote and call callback
        this._saveRemote(data, progress, this._finalizeSave(contentPage, callback));
      }
        // save all progress local and don't care about callback
        this._saveLocal(progress);
      }
      // this.recordMostRecentPage(data);
    },

    _finalizeSave: function(page, callback) {
      return function(progress) {
        page.trigger('page:progress:save');
        callback(progress);
      };
    },

    _saveLocal: function(progress, callback) {
      var progressString = JSON.stringify(progress);
      this.storage.setItem(this.key, progressString);
      if(callback && typeof callback === 'function') {
        callback(progress);
      }
    },

    _saveRemote:function(pageProgress, progress, callback, error) {
      var eid = EF.enrollment.get('id');
      var path = EF.ContentProvider.ProgressService.getPath(eid);
      var self = this;
      var url = EF.url(path);
      EF.progressQueue.enqueue({
        url: url,
        data: pageProgress
      });
      EF.trigger('pageProgress:saved', pageProgress);
      callback(progress);
    },

    get: function() {
      var progress = this.storage.getItem(this.key);
      if(progress && progress !== 'undefined') {
        return JSON.parse(progress);
      }
    },

    getMostRecentPage: function(callback) {
      var lastPage = this.storage.getItem('last_page');
      if(lastPage) {
        callback(JSON.parse(lastPage));
        return;
      }
      callback();
    },

    recordMostRecentPage: function(pageData) {
      var pageString = JSON.stringify(pageData);
      this.storage.setItem('last_page', pageString);
    },

    _getLocal: function(callback) {
      var progress = this.storage.getItem(this.key);
      if(progress) {
        callback( JSON.parse(progress) );
      }
      else {
        callback();
      }
    },

    _getRemote: function(callback) {
      var eid = EF.enrollment.get('id');
      var url = EF.url('/sdk/enrollments/' + eid + '/page_progresses.json');
      var self = this;
      var params = { module_key: this.module.get('key') };

      var tryCount = 0;
      var makeRequest = function() {
        tryCount++;
        $.ajax({
          dataType: ($.support.cors ? 'json' : 'jsonp'),
          url: url,
          callback: 'callback',
          data: params,
          success: function(data, textStatus, jqXHR) {
            if(data) {
              self._saveLocal(data, callback);
            }
            else {
              self._getLocal(callback);
            }
          },
          error: function(jqXHR, textStatus, errorThrown) {
            if(tryCount < 3) {
              makeRequest();
            }
            else {
              alert('Unable to load your progress. please try again later');
              // self._getLocal(callback);
            }
          }
        });
      };
      makeRequest();
    },

    load: function(callback) {
      if(EF.options.local) {
        this._getLocal(callback);
      }
      else {
        this._getRemote(callback);
      }

    },

    forPageAndActivity: function(pageKey, activityKey) {
      var progress = this.get();
      if(!progress) return;
      var actProgress = progress[activityKey];
      if(actProgress) return actProgress[pageKey];
    },

    // Marks an activity complete in the DB.
    markComplete: function() {
      var self = this;
      if(!(this.module && this.module.get('key'))) return;
      var moduleKey = this.module.get('key');
      var grade = this.module.get('grade');
      if(typeof grade === 'undefined') grade = 1; //pass/fail

      if(EF.options.local || EF.enrollment.get('demoMode') === 'preview') {
        this.saveLocalActivityProgress({
          'attempt': 1,
          'enrollment_id': EF.enrollment.get('id'),
          'grade': grade,
          'passed': grade === 1,
          'slug': moduleKey,
          'module_key': moduleKey
        });
      } else {
        EF.ContentProvider.ProgressService.saveActivityProgress(this, grade, 1, moduleKey);
      }
    },

    saveLocalActivityProgress: function(activityProgress) {
      var progress = this.get() || {};
      progress.activity_progresses = progress.activity_progresses || [];
      progress.activity_progresses.push(activityProgress);
      this._saveLocal(progress);
    },

    getLocalActivityProgress: function() {
      var progress = this.get();
      if(progress) {
        return progress.activity_progresses;
      }
    },

    removeLocalActivityProgress: function(slug) {
      var progress = this.get();
      if(progress && progress.activity_progresses) {
        progress.activity_progresses = progress.activity_progresses.filter((ap) => ap.slug !== slug);
        this._saveLocal(progress);
      }
    },

    saveActivityProgress: function(grade, attempt, slug) {
      var params = {
        attempt: attempt,
        grade: grade,
        module_key: slug
      };

      var eid = EF.enrollment.get('id');
      var path = '/sdk/enrollments/' + eid + '/activity_progresses.json';
      var url = EF.url(path);

      EF.progressQueue.enqueue({
        url: url,
        data: params
      });
      this.module.apSaved = true;
      EF.trigger('activityProgress:saved');
    },

    clear: function(callback) {
      if(EF.options.local) {
        this._clearLocal(callback);
      }
      else {
        this._clearRemote(callback);
      }
    },

    _clearLocal: function(callback) {
      this.storage.removeItem(this.key);
      if(callback) {
        callback(true);
      }
    },

    _clearRemote: function(callback) {
      var eid = EF.enrollment.get('id');
      var path = '/sdk/enrollments/' + eid + '/page_progresses/' + this.module.get('key') + '.json';
      var url = EF.url(path);

      var self = this;
      var tryCount = 0;
      var makeRequest = function() {

        var options = {
          dataType: 'jsonp',
          type: 'GET',
          url: url,
          callback: 'callback',
          success: function(data, textStatus, jqXHR) {
            self._clearLocal(callback);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            if(tryCount < 3) {
              makeRequest();
            }
            else {
              alert('Unable to clear your progress. please try again later');
              if(callback) {
                callback(false);
              }
            }
          }
        };

        if($.support.cors) {
          options = _.extend(options, {
            dataType: 'json',
            type: 'DELETE',
            crossDomain: true,
            xhrFields: {
              withCredentials: true
            }
          });
        }
        else {
          // If we don't have CORS, set the method override @ _method
          options.data = {_method: 'DELETE'};
        }

        tryCount++;
        $.ajax(options);
      };
      makeRequest();
    }

  });

  _.extend(EF.Models, {
    ProgressTracker: ProgressTracker
  });
})(EF);
